import Dashboard from './DashBoard'
export default Dashboard
